var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIconImage(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.31507 10.6849H2.23562L7.90685 5.0137L6.9863 4.09315L1.31507 9.76438V10.6849ZM10.7178 4.06027L7.92329 1.29863L8.84384 0.378082C9.09589 0.126027 9.40559 0 9.77293 0C10.1398 0 10.4493 0.126027 10.7014 0.378082L11.6219 1.29863C11.874 1.55068 12.0055 1.8549 12.0164 2.21129C12.0274 2.56723 11.9068 2.87123 11.6548 3.12329L10.7178 4.06027ZM0.657534 12C0.471233 12 0.315178 11.9369 0.18937 11.8106C0.0631234 11.6848 0 11.5288 0 11.3425V9.48493C0 9.39726 0.0164384 9.31244 0.0493151 9.23047C0.0821918 9.14806 0.131507 9.07397 0.19726 9.00822L6.96986 2.23562L9.76438 5.03014L2.99178 11.8027C2.92603 11.8685 2.85216 11.9178 2.77019 11.9507C2.68778 11.9836 2.60274 12 2.51507 12H0.657534ZM7.44658 4.55342L6.9863 4.09315L7.90685 5.0137L7.44658 4.55342Z",
    fill: "#5E05C6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconImage);
export default __webpack_public_path__ + "static/media/editIconImage.0260f878d38fd6af3ca3e458cd054032.svg";
export { ForwardRef as ReactComponent };